<template>

  <div class="workshops-bespoke">

    <nav-1></nav-1>

    <!-- <hero :image="hero"></hero> -->
    <play></play>

    <!-- <div class="hero-wrapper">
      <div class="hero">
        <div class="background" :style="{'backgroundImage':'url(' + hero + ')'}"></div>
        <div class="text">

        </div>
      </div>
    </div> -->

    <h1>
      Playtotype™ Workshops
    </h1>

    <div class="content-text">

      <h4 class="size__content__default pos__content__center">
        At HATO we move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing- through the art of play. Our Playtotype™ programme is designed to engage your teams and audiences to do the same.
      </h4>
      <h4 class="size__content__default pos__content__center">
        Playtotyping™ is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.
      </h4>

<!--
      <h4 class="size__content__default pos__content__center">
        Playtotyping is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.
  \    </h4>
      <h4 class="size__content__default pos__content__center">
        We use design, craft and technology to give people the tools to connect with their inherent creativity, to express their ideas and collaborate with each other.
      </h4>
      <h4 class="size__content__default pos__content__center">
        The overall aim of playtotyping is to move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing through the art of play.
      </h4> -->
    </div>


    <div class="content-text playtotype-info-wrapper" :class="{'expanded': expand}">
      <div class="title">
        <h5 class="what-is" @click="expand=!expand">
          <span v-if="!expand">Read More about Playtotype™</span>
          <span v-if="expand">Close</span>
        </h5>

        <h2>
          Playtotype™
          <small>Play as a Method of Working</small>
        </h2>
      </div>
      <div class="size__content__narrow pos__content__center playtotype-info">
        <p>Playtotyping™ is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.</p>
        <p>We use design, craft and technology to give people the tools to connect with their inherent creativity, to express their ideas and collaborate with each other.</p>
        <p>The overall aim of playtotyping™ is to move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing through the art of play.</p>
        <p>At HATO we believe that being playful and creative are part of the everyday. We use this ethos throughout our own practice. Through our public and private workshops programme we are able to engage others to do the same.</p>
        <img :src="diagram" alt="">
      </div>
      <!-- <div class="expand" @click="expand=!expand">
        <span v-if="!expand">+</span>
        <span v-if="expand">–</span>
      </div> -->
    </div>

    <figure class="media full">
      <img :src="onpress" alt="">
      <figcaption>ON PRESS at Selfridges</figcaption>
    </figure>

    <div class="row col-2 size__content__default pos__content__center workshops">
      <div class="exp-workshop workshop">
        <h2>Experiential Workshops at Hato&nbsp;Press</h2>
        <p>Our experiential workshops are built around teams and groups wanting to explore play and creativity in a fun and inspiring way. Either hosted at our East London studio or at your own space be it your office/studio or temporary space, our team of workshop leaders and printers are able to devise tailored Riso printing and image making sessions that inspire new perspectives amongst teams and ensure a fun and engaging social event. </p>
        <h5>Outcomes</h5>
        <div class="outcomes-boxes">
          <div class="outcomes-box">
            Creative Thinking
          </div>
          <div class="outcomes-box">
            Innovation
          </div>
          <div class="outcomes-box">
            Kinesthetic Learning
          </div>
          <div class="outcomes-box">
            Collaboration
          </div>
          <div class="outcomes-box">
            Team Building
          </div>
          <div class="outcomes-box">
            Visual Learning
          </div>
        </div>
      </div>
      <div class="bes-workshop workshop">
        <h2>Bespoke Workshops<br>for&nbsp;Events</h2>
        <p>Our Bespoke workshops are a chance for your organisation and brand to bring a new level of engagement and fun to an event or brand activation. </p>
        <p>The format and type of bespoke workshop varies greatly, from Riso printing in a department store window to Calligraphy for a retail pop-up, our team can help tailor an activation that will suit your needs and messaging.</p>
        <h5>Outcomes</h5>
        <div class="outcomes-boxes">
          <div class="outcomes-box">
            Consumer<br>Engagement
          </div>
          <div class="outcomes-box">
            New<br>Audiences
          </div>
          <div class="outcomes-box">
            Bespoke Artist<br>Collaborations
          </div>
          <div class="outcomes-box">
            Targeted Brand<br>Messaging
          </div>
          <div class="outcomes-box">
            Product<br>Launches
          </div>
          <div class="outcomes-box">
            Digital and<br>social&nbsp;awareness
          </div>
        </div>
      </div>
    </div>

<!--


    <div class="content-text outcomes">
      <h4 class="size__content__default pos__content__center">
        At HATO we believe that being playful and creative are part of the everyday. We use this ethos throughout our own practice. Through our public and private workshops programme we are able to engage others to do the same.
      </h4>
      <h4 class="size__content__default pos__content__center">
        Our experiential workshops are built around teams and groups wanting to explore play and creativity in a fun and inspiring way. Either hosted at our East London studio or at your own space be it your office/studio or temporary space, our team of workshop leaders and printers are able to devise tailored Riso printing and image making sessions that inspire new perspectives amongst teams and ensure a fun and engaging social event.
      </h4>
    </div> -->
<!--
    <div class="content-text outcomes-visual">
      <h2>Outcomes</h2>
      <div class="outcomes-boxes">
        <div class="outcomes-box">
          Creative Thinking
        </div>
        <div class="outcomes-box">
          Wellbeing
        </div>
        <div class="outcomes-box">
          Innovation
        </div>
        <div class="outcomes-box">
          Team Building
        </div>
        <div class="outcomes-box">
          Re-Engage<br>Kinesthetic
        </div>
        <div class="outcomes-box">
          Increase Visual<br>Learning methods
        </div>
      </div>
    </div> -->

    <div class="content-text download">
      <div class="action">
        <h4>Find out more about prices and tailored packages</h4>
        <a href="../static/Hato-Bespoke-Workshops-Package-June-2019.pdf" target="_blank" class="icon">
          <svg width="22px" height="24px" viewBox="0 0 22 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="-" transform="translate(-5.000000, -4.000000)" stroke="#000000" stroke-width="2" fill="none">
                <polyline id="Rectangle" transform="translate(15.949747, 18.449747) rotate(-315.000000) translate(-15.949747, -18.449747) " points="19.4497475 14.9497475 19.4497475 21.9497475 12.4497475 21.9497475"></polyline>
                <path d="M16,23 L16,5.90987723" id="Line" stroke-linecap="square"></path>
                <path d="M6.5,27 L25.2871094,27" id="Line-2" stroke-linecap="square"></path>
              </g>
            </g>
          </svg>
          <span>Download Information Pack</span>
        </a>
      </div>
    </div>

    <div class="carousel-wrapper testimonials">

      <h2>What our clients say</h2>

      <flickity class="carousel" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell">
          <div class="quote">
            <h3>“Hato’s energy and enthusiasm for playing with printing led to an imaginative and fun day for families at the&nbsp;RA.”</h3>
            <p>Gwen Ramsay, Family Programmer, Royal Academy of&nbsp;Arts.</p>
          </div>
        </div>
        <div class="carousel-cell">
          <div class="quote">
            <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to&nbsp;Hato.”</h3>
            <p>Shirley, Senior Copywriter, Virgin&nbsp;Media</p>
          </div>
        </div>
        <div class="carousel-cell">
          <div class="quote">
            <h3>“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to&nbsp;anyone!”</h3>
            <p>Emma, Graphic Designer, Boden</p>
          </div>
        </div>
        <div class="carousel-cell">
          <div class="quote xl">
            <!-- <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. Most had very little knowledge of Riso before hand and so was a lot of fun making a mess together, experimenting with ideas and picking your colours! The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3> -->
            <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than&nbsp;others!).”</h3>
            <p>Helen Scibilia, Project Manager, YCN</p>
          </div>
        </div>
        <div class="carousel-cell">
          <div class="quote">
            <h3>“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a&nbsp;beer&nbsp;;-).”</h3>
            <p>Alex Prior, Head of Graphic Design at The&nbsp;Hoxton</p>
          </div>
        </div>
      </flickity>
    </div>

    <!-- <div class="quotes size__content__wide pos__content__center">
      <div class="quote">
        <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”</h3>
        <p>Shirley, Senior Copywriter, Virgin Media</p>
      </div>
      <div class="quote">
        <h3>“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”</h3>
        <p>Emma, Graphic Designer, Boden</p>
      </div>
      <div class="quote">
        <h3>“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”</h3>
        <p>Alex Prior, Head of Graphic Design at The Hoxton</p>
      </div>
      <div class="quote">
        <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3>
        <p>Helen Scibilia, Project Manager, YCN</p>
      </div>
    </div> -->




    <!-- <div class="content-text">
      <img class="size__content__narrow" src="../assets/clients/corporate-logo-blocks.png" alt="">
    </div> -->
    <div class="content-logos">
      <img class="size__content__narrow" src="../assets/clients/playtotype-logos.png" alt="">
    </div>


    <div class="content-text cta">
      <div class="action">
        <h3>Let's begin.</h3>
        <a href="mailto:bespoke@hatopress.net?subject=Bespoke Workshops">bespoke@hatopress.net</a>
        <a href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
        <a href="../static/Hato-Bespoke-Workshops-Package-June-2019.pdf" target="_blank" class="icon">
          <svg width="22px" height="24px" viewBox="0 0 22 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="-" transform="translate(-5.000000, -4.000000)" stroke="#000000" stroke-width="2" fill="none">
                <polyline id="Rectangle" transform="translate(15.949747, 18.449747) rotate(-315.000000) translate(-15.949747, -18.449747) " points="19.4497475 14.9497475 19.4497475 21.9497475 12.4497475 21.9497475"></polyline>
                <path d="M16,23 L16,5.90987723" id="Line" stroke-linecap="square"></path>
                <path d="M6.5,27 L25.2871094,27" id="Line-2" stroke-linecap="square"></path>
              </g>
            </g>
          </svg>
          <span>Download Information Pack</span>
        </a>
      </div>
    </div>
    <!-- <div class="content-text">
      <p>&nbsp;</p>
    </div> -->
    <!-- <div class="action-wrapper">
      <div class="action">
        <h3>Let us plan your next event,<br>book a bespoke session with us.</h3>
        <a href="#">learn@hatopress.net</a>
        <a href="#">+44 (0)207 729 5585</a>
      </div>
    </div> -->

  </div>

</template>

<script>

import Nav1 from '@/components/Nav1'
import Flickity from '@/components/Flickity'
import Hero from '@/components/Hero'
import Newsletter from '@/components/Newsletter'
import Play from '@/components/Play'

export default {
  ready: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  beforeDestroy: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  components: {
    Nav1,
    Flickity,
    Hero,
    Newsletter,
    Play
  },
  mounted () {
    this.$refs.flickity.initFlickity()
  },
  data () {
    return {
      onpress: require('../assets/workshops/Hato-Selfridges-ON-PRESS-3600-6R9A3308.jpg'),
      diagram: require('../assets/workshops/HATO-Playtotype-Diagram.png'),
      carousel: [
        {
          text: 'Bao',
          image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
        }
      ],
      flickityOptions: {
        contain: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: false
      },
      expand: false
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  margin-top: 0;
  /*text-align: center;*/
}
img {

}
small {
  display: block;
  margin: .5em;
  font-size: 60%
}
h1 {
  margin-top: 4rem
}
h2,h3,h4,h5 {
  text-align: center;
}

figure {
  position: relative;
}
figure img {
  display: block;
  margin: 0;
}
figcaption {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: .5rem 1rem;
  font-size: 0.66rem;
  color: white;
}

.content-text {
  background: #fdda58;
  background: #fff;
  margin: auto;
  padding: 1rem 1rem 1rem;
  margin: 0 auto;
  text-align: left;
  /*max-width: 1000px;*/
}

.content-text h4 {
  margin-bottom: 1rem;
}

.content-logos {
  margin: 4rem auto 6rem;
}

.content-text.outcomes {
  background: #eee;
}

.action-wrapper {
  /*background: #f0f0f0;*/
  padding: 1rem 0;
}

.cta {
  /* background: yellow */
  background: #fafafa;
}

.action {
  padding: 2rem 0;
  margin: 0 auto;
  max-width: 800px;
  text-align: center;
}
.action a {
  display: inline-block;
  margin: .5rem .25rem;
  padding: .5em 1em;
  border-radius: 5px;
  /*border: 1px solid #000;*/
  background: hsl(158, 81%, 57%)
}
.action a:hover {
  background: hsl(158, 81%, 77%);
}
a.icon svg {
  height: 1rem;
  width: 1rem;
  display: inline-block;
  vertical-align: sub
}

.flash {
   animation-name: flash;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}


@keyframes flash {
    0% {color: red;}
    20% {color: yellow;}
    40% {color: green;}
    60% {color: blue;}
    80% {color: pink;}
    100% {color: red;}
}




/* .quotes {
  padding: 0rem 0 0rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
} */
.quote:nth-child(2n) {
  background:
  /*align-self: flex-end;*/
}

.layout-b {
  /*background: rgb(55,234,168);*/
  max-width: 100%;
  justify-content: center;
  align-items: center;
}

.testimonials {
  background: #003;
  color: white;
}

.carousel-wrapper {
  padding: 1rem 0 2rem;
  width: 100%;
  position: relative;
}
.carousel {
  top:0;
  left: 0;
  width: 100%;
}
.carousel-cell {
  /* width: 900px;
  height: 550px;
  margin: 0 .5rem; */
  margin: 0 0;
  width: 90%;
  max-width: 500px;
  padding: .5rem;
}
.carousel-cell:first-child {
  padding-left: 1rem
}
.carousel-cell:last-child {
  padding-right: 1rem
}
.quote {
  /* width: 49%; */
  color: black;
  /* width: 90%;
  max-width: 500px; */
  padding: 2rem 2rem 2rem;
  border-radius: 5px;
  background: hsl(186, 81%, 57%);
}
.quote.xl {
  max-width: 700px;
}
.quote h3 {
  text-align: left;
}

.outcomes-visual {
  background:;
}
.outcomes-boxes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  max-width: 1000px;
  padding: 1rem 0 2rem;
}
.outcomes-box {
  padding: 1rem;
  background: yellow;
  font-size: .8rem;
  margin: .5rem;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.workshops {
  padding-top: 2rem;
}
.workshop {
  padding: 0 1rem;
}

.row {
  display: flex;
}
.col-2 > div {
  width: 50%;
}

.what-is {
  cursor: pointer;
  margin: 1rem auto 3rem;
  border: 1px solid;
  width: 18rem;
  padding: .25rem 0;
  border-radius: 1rem;
  transition: .2s ease-in-out all;
}
.what-is:hover {
  background: yellow;
  transform: scale(1.04);
}

.expanded .what-is {
  border-color: transparent;
  opacity: 0.5;
}

.playtotype-info-wrapper {
  padding: 0 1rem 0;
  transition: 1s ease-in-out all;
  max-height: 4rem;
  margin-bottom: 3rem;
  overflow: hidden;
  position: relative;
}

.playtotype-info-wrapper.expanded {
  padding: 0 1rem 5rem;
  max-height: 100rem;
  background: yellow;
  margin-bottom: 0;
}
.playtotype-info img {
  max-width: 400px;
}

@media screen and (max-width: 1024px) {
  /* .quotes {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .content-logos {
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  } */
}
@media screen and (max-width: 768px) {
}
@media screen and (max-width: 640px) {
  .outcomes-box {
    font-size: 1rem;
    padding: 1rem;
  }
  .col-2 {
    flex-wrap: wrap;
  }
  .col-2 > div {
    width: 100%;
  }
  .workshop {
    margin-bottom: 3rem
  }
  /* .quotes {
    flex-direction: column;
  }
  .quote {
    width: 100%;
    margin-top: 0;
    margin-bottom: 1rem;
  }
  .action a {
    margin: .5em 1em;
  } */
}
</style>



// WEBPACK FOOTER //
// WorkshopsExperiential.vue?79d58504